const URL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API : 'http://localhost:8000/';
export default URL;  